import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, Phone } from "lucide-react";
import { COMPANY } from "@/lib/data";

export default function FinalCTA() {
  const scroll = () =>
    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section
      className="py-24 lg:py-40 bg-[#FDFBF7] relative overflow-hidden"
      data-testid="final-cta"
    >
      {/* Big rotating circles backdrop */}
      <div className="absolute -right-40 top-1/2 -translate-y-1/2 opacity-[0.05] pointer-events-none">
        <svg width="700" height="700" viewBox="0 0 100 100">
          <circle cx="50" cy="50" r="45" fill="none" stroke="#0F172A" strokeWidth="1" />
          <circle cx="50" cy="50" r="35" fill="none" stroke="#0F172A" strokeWidth="1" />
          <circle cx="50" cy="50" r="25" fill="none" stroke="#0F172A" strokeWidth="1" />
        </svg>
      </div>

      <div className="max-w-[1240px] mx-auto px-6 lg:px-10 relative">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9 }}
            className="lg:col-span-7"
          >
            <div className="eyebrow mb-4">Prêt à commencer ?</div>
            <h2 className="font-serif-display font-medium text-[40px] sm:text-[60px] lg:text-[86px] leading-[0.98] tracking-tight text-[#0F172A] balance">
              Laissez-nous <em className="not-italic text-[#2D7A4D]">nous en occuper.</em>
            </h2>
            <p className="mt-6 text-[17px] lg:text-[19px] text-[#334155] leading-relaxed max-w-xl">
              La vie est assez compliquée sans stresser sur votre facture
              d'énergie. Ouvrez votre dossier HMCD gratuitement et découvrez
              votre plan d'économies personnalisé.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9 }}
            className="lg:col-span-5 bg-[#0F172A] text-[#FDFBF7] rounded-3xl p-8 lg:p-10"
          >
            <div className="font-mono-tech text-[10px] uppercase tracking-[0.22em] text-[#FDFBF7]/60 mb-4">
              Ouvrir un dossier · 3 minutes
            </div>
            <div className="font-serif-display text-3xl lg:text-4xl leading-[1.05] text-[#FDFBF7] mt-2">
              On vous rappelle sous 24 h.
            </div>
            <p className="mt-5 text-[15px] text-[#FDFBF7]/70 leading-relaxed">
              Étude technique gratuite. Chiffrage détaillé. Montage des aides
              MaPrimeRénov' et CEE. Sans avance de trésorerie.
            </p>

            <div className="mt-8 space-y-3">
              <button
                data-testid="final-cta-btn"
                onClick={scroll}
                className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-[#FF9800] hover:bg-[#BF4300] transition-colors py-4 text-[#0F172A] font-semibold text-[15px]"
              >
                Ouvrir mon dossier
                <ArrowRight className="h-4 w-4" />
              </button>
              <a
                href={`tel:${COMPANY.phoneRaw}`}
                data-testid="final-cta-call"
                className="w-full inline-flex items-center justify-center gap-2 rounded-full border border-[#FDFBF7]/25 hover:border-[#FDFBF7] transition-colors py-3.5 text-[#FDFBF7] font-medium text-[15px]"
              >
                <Phone className="h-4 w-4" />
                {COMPANY.phone}
              </a>
            </div>

            <div className="mt-4 text-xs text-[#FDFBF7]/50 text-center">
              Sans engagement · RGE QualiPV · Qualibat 7141
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
